// extracted by mini-css-extract-plugin
module.exports = {"banner":"styles_banner__8zxWj","wrapper":"styles_wrapper__OPETQ","top":"styles_top__pgFOc","title":"styles_title__IwV_Y","description":"styles_description__Ro0_D"};